type ConfirmMappingBannerProps = {
  onConfirm: () => void;
  isConfirmed?: boolean;
  confirmedCount?: number;
};

const ConfirmMappingBanner = ({ onConfirm, isConfirmed = false, confirmedCount = 0 }: ConfirmMappingBannerProps) => (
  <div className="tw-mx-auto tw-flex tw-w-fit tw-items-center tw-gap-4 tw-rounded-md tw-bg-primary-purple-50 tw-px-4 tw-py-2.5">
    <span className="tw-text-sm tw-text-gray-900">{isConfirmed ? `Mapping confirmed for ${confirmedCount} companies. Trade information is now available.` : "Confirm mapping to view trade information for the uploaded companies"}</span>
    {!isConfirmed && (
      <>
        <span className="tw-h-6 tw-w-px tw-bg-gray-400" />
        <button type="button" onClick={onConfirm} className="tw-flex tw-items-center tw-gap-1 tw-border-none tw-bg-transparent tw-p-0 tw-text-sm tw-font-medium tw-text-primary-purple-600 hover:tw-underline">
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor">
            <path d="m428.23-349.85 224.92-223.92L616-610.92 428.23-424.15l-85-84L306.08-471l122.15 121.15ZM480.07-116q-74.84 0-141.21-28.42t-116.18-78.21q-49.81-49.79-78.25-116.13Q116-405.1 116-479.93q0-75.84 28.42-141.71t78.21-115.68q49.79-49.81 116.13-78.25Q405.1-844 479.93-844q75.84 0 141.71 28.42t115.68 78.21q49.81 49.79 78.25 115.63Q844-555.9 844-480.07q0 74.84-28.42 141.21t-78.21 116.18q-49.79 49.81-115.63 78.25Q555.9-116 480.07-116Z" />
          </svg>
          Confirm
        </button>
      </>
    )}
  </div>
);

export default ConfirmMappingBanner;
